<template>
  <div id="login_page" v-hotkey="keymap" class="demo-login">
    <div class="demo-login__background" aria-hidden="true">
      <span class="demo-login__shape demo-login__shape--primary"></span>
      <span class="demo-login__shape demo-login__shape--corner"></span>
      <span class="demo-login__shape demo-login__shape--secondary"></span>
    </div>
    <a class="demo-login__back" :href="redirectLandingUrl">
      <v-icon size="19">mdi-arrow-left</v-icon>
      Повернутися на сайт
    </a>
    <v-row class="demo-login__row" align="center" justify="center">
      <v-col class="demo-login__column" cols="12">
        <div class="demo-login__logo-wrap">
          <HolidayDoodle class="demo-login__doodle" />
          <img class="demo-login__logo" src="../../../style/img/logo.svg" alt="Red Fox Home School" />
        </div>
        <v-card class="demo-login__card" elevation="0">
          <header class="demo-login__header">
            <span class="demo-login__icon"><v-icon size="27">mdi-school-outline</v-icon></span>
            <div>
              <h1>Демо-кабінет учня</h1>
              <p>Оберіть клас — ми покажемо доступні предмети та приклад уроку</p>
            </div>
          </header>
          <v-form ref="form" class="demo-login__form" @submit.prevent="open">
            <div class="demo-login__field">
              <label for="demo-login-class">Для якого класу показати демо?</label>
              <v-select
                id="demo-login-class"
                v-model="selectedLesson"
                :items="lessons"
                background-color="#fff"
                hide-details
                outlined
                placeholder="Оберіть клас"
                prepend-inner-icon="mdi-book-open-page-variant-outline"
              />
            </div>
            <button type="submit" class="demo-login__submit" :disabled="!selectedLesson">
              Перейти до демо <v-icon color="#fff" size="20">mdi-arrow-right</v-icon>
            </button>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <label v-if="showStageDoodlePreview" class="demo-login__preview-control">
      <span>Stage: святковий дудл</span>
      <select v-model="holidayPreviewSelection" @change="applyHolidayPreview">
        <option
          v-for="option in holidayPreviewOptions"
          :key="option.value"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
    </label>
  </div>
</template>

<script>
import HolidayDoodle from '@/components/Base/HolidayDoodle/HolidayDoodle';

export default {
  name: 'SelectLessonPage',
  components: { HolidayDoodle },
  data() {
    return {
      selectedLesson: '',
      lessons: [],
      uri: '/school/?demoToken=',
      holidayPreviewSelection: '',
      holidayPreviewOptions: [
        { value: '', label: 'За календарем' },
        { value: 'none', label: 'Без дудла' },
        { value: 'knowledge-day', label: 'День знань' },
        { value: 'educators-day', label: 'День працівників освіти' },
        { value: 'saint-nicholas-day', label: 'День святого Миколая' },
        { value: 'winter-holiday', label: 'Різдвяно-зимові свята' },
        { value: 'easter', label: 'Великдень' },
        { value: 'vyshyvanka-day', label: 'День вишиванки' },
        { value: 'last-bell', label: 'Останній дзвоник' },
        { value: 'independence-day', label: 'День Незалежності' },
      ],
    };
  },
  mounted() {
    this.$store.dispatch('ThemeStore/initialize');
    this.holidayPreviewSelection =
      this.$store.getters['ThemeStore/getPreviewHolidayCode'] || '';
    this.lessons = this.$_createLessons();
  },
  computed: {
    keymap() { return { enter: this.open }; },
    demoClassConfig() { return this.$store.getters['ConfigStore/getDemoClassConfig']; },
    redirectLandingUrl() {
      return this.$store.getters['ConfigStore/getRedirectLandingUrl'] || '/';
    },
    showStageDoodlePreview() {
      return (
        this.$store.getters['ConfigStore/isStage'] ||
        this.$store.getters['ConfigStore/isLocal']
      );
    },
  },
  methods: {
    async applyHolidayPreview() {
      await this.$store.dispatch(
        'ThemeStore/setHolidayPreview',
        this.holidayPreviewSelection
      );
    },
    open() {
      if (!this.selectedLesson) return;
      window.location.href = `${this.uri}${this.selectedLesson}`;
    },
    $_createLessons() {
      return this.demoClassConfig.map((item) => ({ text: item.classLabel, value: item.token }));
    },
  },
};
</script>

<style lang="less" scoped>
.demo-login {
  align-items: center; background: var(--theme-app-background); box-sizing: border-box;
  display: flex; height: 100vh; inset: 0; overflow-y: auto; padding: 28px 24px;
  position: fixed; transition: background-color .25s ease; width: 100vw;
}
#login_page.demo-login { background-image: none; max-width: none; }
.demo-login__background { inset: 0; overflow: hidden; pointer-events: none; position: absolute; }
.demo-login__back {
  align-items: center; border-radius: 9px; color: var(--text-secondary); display: flex;
  font-size: 14px; font-weight: 700; gap: 6px; left: 24px; padding: 8px 10px;
  position: fixed; text-decoration: none; top: 20px; transition: background .15s, color .15s; z-index: 6;
}
.demo-login__back::v-deep .v-icon { color: currentColor; }
.demo-login__back:hover { background: rgba(255,255,255,.72); color: var(--theme-header-background); }
.demo-login__back:focus-visible { outline: 3px solid var(--theme-accent-decorative); outline-offset: 2px; }
.demo-login__shape {
  display: block; position: absolute; transition: background-color .25s ease;
  -webkit-mask-position: center; -webkit-mask-repeat: no-repeat; -webkit-mask-size: contain;
  mask-position: center; mask-repeat: no-repeat; mask-size: contain;
}
.demo-login__shape--primary {
  aspect-ratio: 1209/823; background: var(--theme-banner-background); bottom: -100px; left: 0;
  max-width: 1209px; width: 76vw; -webkit-mask-image: url("../../../style/img/green.svg");
  mask-image: url("../../../style/img/green.svg");
}
.demo-login__shape--corner {
  aspect-ratio: 383/429; background: var(--theme-surface-decorative); left: -100px; max-width: 383px;
  top: 0; width: 25vw; -webkit-mask-image: url("../../../style/img/orange.svg");
  mask-image: url("../../../style/img/orange.svg");
}
.demo-login__shape--secondary {
  aspect-ratio: 933/800; background: var(--theme-accent-decorative); bottom: -200px; max-width: 933px;
  right: 0; width: 59vw; -webkit-mask-image: url("../../../style/img/green2.svg");
  mask-image: url("../../../style/img/green2.svg");
}
.demo-login__row { margin: 0; position: relative; transform: translateY(-44px); width: 100%; z-index: 1; }
.demo-login__column { align-items: center; display: flex; flex-direction: column; gap: 18px; max-width: 460px; padding: 12px; }
.demo-login__logo-wrap { align-items: center; display: flex; justify-content: center; position: relative; }
.demo-login__logo { display: block; height: auto; position: relative; width: 210px; z-index: 4; }
.demo-login__doodle { height: 138px; top: 41%; width: 480px; z-index: 2; }
.demo-login__doodle::v-deep .holiday-doodle__art { height: 138px; width: 450px; }
.demo-login__doodle.holiday-doodle--vyshyvanka-day { left: 50%; top: 42%; transform: translate(-50%, -50%); }
.demo-login__doodle.holiday-doodle--vyshyvanka-day::v-deep .holiday-doodle__art { width: 470px; }
.demo-login__card {
  background: rgba(255,255,255,.96) !important; border: 1px solid var(--theme-border-decorative) !important;
  border-radius: 20px !important; box-shadow: 0 18px 48px rgba(31,41,55,.13) !important;
  overflow: hidden; padding: 28px; width: 100%;
}
.demo-login__header { align-items: center; display: flex; gap: 14px; margin-bottom: 25px; }
.demo-login__icon {
  align-items: center; background: var(--theme-banner-background); border-radius: 13px; display: flex;
  flex: 0 0 auto; height: 52px; justify-content: center; width: 52px;
}
.demo-login__icon::v-deep .v-icon { color: var(--theme-header-background) !important; }
.demo-login__header h1 { color: #172033; font-size: 23px; line-height: 1.25; margin: 0 0 4px; }
.demo-login__header p { color: #7a8592; font-size: 13px; margin: 0; }
.demo-login__form { display: flex; flex-direction: column; gap: 20px; }
.demo-login__field > label { color: #344054; display: block; font-size: 13px; font-weight: 750; margin-bottom: 7px; }
.demo-login__field::v-deep .v-input__slot { align-items: center; border-radius: 11px !important; min-height: 56px !important; }
.demo-login__field::v-deep .v-input__prepend-inner,
.demo-login__field::v-deep .v-input__append-inner { align-self: center; margin-top: 0 !important; }
.demo-login__field::v-deep .v-input__prepend-inner { margin-right: 12px; }
.demo-login__field::v-deep .v-input__slot fieldset { border-color: var(--theme-border-decorative); }
.demo-login__field::v-deep .v-input--is-focused .v-input__slot fieldset { border-color: var(--theme-header-background) !important; }
.demo-login__field::v-deep .v-input--is-focused .v-icon { color: var(--theme-header-background) !important; }
.demo-login__submit {
  align-items: center; background: var(--theme-header-background); border: 0; border-radius: 11px; color: #fff;
  cursor: pointer; display: flex; font-size: 15px; font-weight: 850; gap: 9px; justify-content: center;
  min-height: 50px; padding: 10px 18px; transition: box-shadow .15s, filter .15s, transform .15s; width: 100%;
}
.demo-login__submit:hover:not(:disabled) { box-shadow: 0 8px 20px rgba(31,41,55,.18); filter: brightness(.9); transform: translateY(-1px); }
.demo-login__submit:disabled {
  background: #aab7c4; color: #fff; cursor: not-allowed; opacity: .78;
}
.demo-login__submit:focus-visible { outline: 3px solid var(--theme-accent-decorative); outline-offset: 3px; }
.demo-login__preview-control {
  background: rgba(255,255,255,.94); border: 1px solid var(--theme-border-decorative);
  border-radius: 12px; bottom: 18px; box-shadow: 0 8px 24px rgba(31,41,55,.12);
  display: flex; flex-direction: column; gap: 6px; padding: 10px 12px;
  position: fixed; right: 18px; width: 250px; z-index: 7;
}
.demo-login__preview-control span {
  color: var(--text-secondary); font-size: 11px; font-weight: 800; text-transform: uppercase;
}
.demo-login__preview-control select {
  background: var(--surface-primary); border: 1px solid var(--theme-border-decorative);
  border-radius: 8px; color: var(--text-primary); min-height: 36px; padding: 0 9px;
}
@media (max-width: 600px) {
  .demo-login { padding: 18px 12px; }
  .demo-login__back { left: 10px; top: 8px; }
  .demo-login__row { transform: translateY(-18px); }
  .demo-login__column { gap: 12px; }
  .demo-login__logo { width: 175px; }
  .demo-login__doodle { transform: translate(-50%, -50%) scale(.78); }
  .demo-login__card { border-radius: 16px !important; padding: 22px 18px; }
  .demo-login__header h1 { font-size: 20px; }
  .demo-login__shape--corner { width: 42vw; }
  .demo-login__shape--primary { width: 115vw; }
  .demo-login__shape--secondary { width: 88vw; }
  .demo-login__preview-control { bottom: 10px; left: 12px; right: 12px; width: auto; }
}
@media (max-height: 760px) {
  .demo-login { align-items: flex-start; padding-top: 58px; }
  .demo-login__row { transform: none; }
  .demo-login__logo { width: 170px; }
  .demo-login__doodle { transform: translate(-50%, -50%) scale(.8); }
  .demo-login__card { padding: 22px; }
}
</style>
